<template>
  <gh-table-page ref="table" :args-query="args" module="dynamic_parse_page" cls="5cc85475d108615bf41299e2"
    :template-model="templateModel">
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
    <template #area_operation_new>
      <div v-show="bomVersion">
        <gh-material-selector title="新增" @submit="submit"></gh-material-selector>
      </div>
    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Bom from "./bom.ts";
  export default Bom;
</script>